module.exports = __webpack_public_path__ + "static/media/text-to-speech.f37557ad.png";